import request from '../libs/request';

const res = 'Notification';

export default {
  queryMy(filter) {
    return request({
      url: `api/${res}/queryMy`,
      method: 'post',
      data: filter
    });
  },
  read(id) {
    return request({
      url: `api/${res}/read`,
      method: 'post',
      data: {
        id
      }
    });
  },
  clear() {
    return request({
      url: `api/${res}/clear`,
      method: 'post'
    });
  }
};
